// extracted by mini-css-extract-plugin
export var measureBox = "_dg-0";